import {
  InboxAuthorizationResponseSchema,
  MessagingCapabilitiesResponseSchema,
  PropertyCoversResponseSchema,
} from '../../schemas/inbox-workspace-reads'
import { V1RequestError, type V1Transport } from '../transport'

function workspacePath(workspaceId: string, resource: string) {
  if (!workspaceId) {
    throw new V1RequestError('INVALID_ARGUMENTS', 'Workspace is required.', null, false)
  }
  return `/api/v1/workspaces/${encodeURIComponent(workspaceId)}/${resource}`
}

export function createInboxWorkspaceReadsClient({ read }: V1Transport) {
  return {
    /** Whether the caller can open the Inbox, and which inboxes. */
    authorization({ workspaceId }: { workspaceId: string }) {
      return read(
        workspacePath(workspaceId, 'inbox-authorization'),
        InboxAuthorizationResponseSchema
      )
    },
    /** The providers, WhatsApp number and SMS lines the composer can send through. */
    messagingCapabilities({ workspaceId }: { workspaceId: string }) {
      return read(
        workspacePath(workspaceId, 'messaging-capabilities'),
        MessagingCapabilitiesResponseSchema
      )
    },
    /** The cover image of each property, from 1 to 100 per call. */
    propertyCovers({ workspaceId, propertyIds }: { workspaceId: string; propertyIds: string[] }) {
      if (propertyIds.length === 0) {
        throw new V1RequestError(
          'INVALID_ARGUMENTS',
          'At least one property is required.',
          null,
          false
        )
      }
      const query = new URLSearchParams({ ids: propertyIds.join(',') })
      return read(
        `${workspacePath(workspaceId, 'property-covers')}?${query}`,
        PropertyCoversResponseSchema
      )
    },
  }
}
